import '../../../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { nothing as w, html as $ } from '../../../../../../node_modules/lit-html/lit-html.js';
import '../../../../../../node_modules/lit-element/lit-element.js';
import { unsafeHTML as o } from '../../../../../../node_modules/lit-html/directives/unsafe-html.js';

/* eslint-disable sonarjs/cognitive-complexity */
function renderCourseModal(isOpen, activeItem, onClose) {
    if (!isOpen || !activeItem) {
        return w;
    }
    const title = activeItem.title || '';
    const metaText = activeItem.meta || '';
    const description = activeItem.description || '';
    const imageSrc = activeItem.imageSrc || '';
    const imageAlt = activeItem.imageAlt || title;
    const primaryCtaLink = activeItem.modalPrimaryCtaLink || '';
    const primaryCtaLabel = activeItem.modalPrimaryCtaLabel || '';
    const secondaryCtaLink = activeItem.modalSecondaryCtaLink || '';
    const secondaryCtaLabel = activeItem.modalSecondaryCtaLabel || '';
    const tags = Array.isArray(activeItem.tags) ? activeItem.tags : [];
    const onOverlayClick = (event) => {
        const target = event.target;
        const isOverlay = Boolean(target && target.classList.contains('gallery-modal-overlay'));
        if (isOverlay) {
            onClose();
        }
    };
    const stopPropagation = (event) => {
        event.stopPropagation();
    };
    let metaTemplate = w;
    if (metaText) {
        metaTemplate = $ `<div class="gallery-modal-meta">${metaText}</div>`;
    }
    let descriptionTemplate = w;
    if (description) {
        descriptionTemplate = $ `<div class="gallery-modal-description">${o(description)}</div>`;
    }
    let tagsTemplate = w;
    if (tags.length) {
        const tagItems = tags.map((tag, index) => {
            const isLast = index === tags.length - 1;
            if (isLast) {
                return $ `<span class="gallery-modal-tag">${tag}</span>`;
            }
            return $ `<span class="gallery-modal-tag">${tag}</span><span> - </span>`;
        });
        tagsTemplate = $ `<div class="gallery-modal-tags" aria-label="Tags">${tagItems}</div>`;
    }
    let primaryCta = w;
    if (primaryCtaLink) {
        primaryCta = $ `<a class="gallery-modal-cta gallery-modal-cta-primary" href="${primaryCtaLink}" target="_blank" rel="noopener noreferrer">${primaryCtaLabel}</a>`;
    }
    let secondaryCta = w;
    if (secondaryCtaLink) {
        secondaryCta = $ `<a class="gallery-modal-cta gallery-modal-cta-secondary" href="${secondaryCtaLink}" target="_blank" rel="noopener noreferrer">${secondaryCtaLabel}</a>`;
    }
    let imageTemplate = w;
    if (imageSrc) {
        imageTemplate = $ `<div class="gallery-modal-image"><img src="${imageSrc}" alt="${imageAlt}" loading="lazy"></div>`;
    }
    return $ `<div class="gallery-modal-overlay" role="presentation" @click="${onOverlayClick}"><div class="gallery-modal"><button class="gallery-modal-close" type="button" aria-label="Close" @click="${onClose}">×</button><section class="gallery-modal-container" role="dialog" aria-modal="true" aria-label="${title}" @click="${stopPropagation}" @keydown="${(event) => {
        if (event.key === 'Escape') {
            onClose();
        }
    }}"><div class="gallery-modal-scroll"><div class="gallery-modal-content"><h2 class="gallery-modal-title">${title}</h2>${metaTemplate} ${descriptionTemplate} ${tagsTemplate}<div class="gallery-modal-actions">${primaryCta} ${secondaryCta}</div>${imageTemplate}</div></div></section></div></div>`;
}

export { renderCourseModal };
